import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { SITE } from "@/data/site";

export default function CtaBand({
  title = "Ready to power your project?",
  subtitle = "Request a quote and Marcos will follow up to discuss your electrical or security project.",
}) {
  return (
    <section className="relative overflow-hidden border-y border-amber-400/20 bg-[#0e0e13]" data-testid="cta-band">
      <div className="absolute inset-0 grid-dots opacity-60" />
      <div
        className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full"
        style={{ background: "radial-gradient(circle, rgba(245,158,11,0.15), transparent 70%)" }}
      />
      <div className="container-kx relative flex flex-col items-start justify-between gap-6 py-14 md:flex-row md:items-center lg:py-16">
        <div className="max-w-xl">
          <h2 className="font-display text-2xl font-extrabold uppercase leading-tight text-white sm:text-3xl">
            {title}
          </h2>
          <p className="mt-3 text-neutral-400">{subtitle}</p>
        </div>
        <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
          <Link
            to="/request-a-quote"
            data-testid="cta-quote-btn"
            className="rounded-full bg-amber-400 px-7 py-3.5 text-center text-sm font-bold uppercase tracking-wide text-[#0A0A0C] transition-all hover:bg-amber-300 hover:shadow-lg hover:shadow-amber-400/25"
          >
            Request a Quote
          </Link>
          <a
            href={SITE.phonePrimary.tel}
            data-testid="cta-call-btn"
            className="flex items-center justify-center gap-2 rounded-full border border-[#2e2e39] px-7 py-3.5 text-sm font-bold text-white transition-colors hover:border-amber-400/60"
          >
            <Phone className="h-4 w-4 text-amber-400" /> Call {SITE.phonePrimary.display}
          </a>
        </div>
      </div>
    </section>
  );
}
